/**
 * Author box tabs.
 *
 * Ported from the Fancier Author Box plugin when that plugin was removed. The
 * first panel is shown on load; clicking a tab swaps panels within that box,
 * so several boxes on one page stay independent.
 */
(function($) {
  $.fn.authorBoxTabs = function() {
    return this.each(function() {
      var $box = $(this);

      $box.find('.author-box__tabs li').first().addClass('is-active');
      $box.find('.author-box__panel').first().addClass('is-active');

      $box.on('click', '.author-box__tabs a', function(event) {
        event.preventDefault();

        var target = $(this).attr('href').split('#')[1];

        $box.find('.author-box__tabs li').removeClass('is-active');
        $(this).parent().addClass('is-active');

        $box.find('.author-box__panel').removeClass('is-active');
        $box.find('#' + target).addClass('is-active');
      });
    });
  };
})(jQuery);
